export default __webpack_public_path__ + "static/tomorrowland-1-97820cdd6574aefda02e7bfd2e680cbc.jpg";